import { useKFlags } from '@/hooks/use-k-flags';

import { DARK_MODE_FLAG } from './colorMode.constants';

/** True only when the `fe-dark-mode` flag is explicitly on. */
export const useIsDarkModeEnabled = (): boolean => {
  const flags = useKFlags() as Record<string, unknown> | undefined;
  return flags?.[DARK_MODE_FLAG] === true;
};
